import classNames from 'classnames';
import { Icon, ContentBlock, FlexContainer, View } from 'components';
import styles from './IconBlock.module.scss';

/**
 * IconBlock
 *
 * @return {JSX.Element}
 */
const IconBlock = ({ className, title, icon, children, onClick, ...rest }) => {
  return (
    <ContentBlock
      noPadding
      className={classNames(styles.IconBlock, className, IconBlock.displayName)}
      column
      overflowHidden
      onClick={onClick}
    >
      <FlexContainer className={styles.Header}>
        <FlexContainer flex>{title}</FlexContainer>
        {icon ? (
          <View className={styles.IconWrap}>
            <Icon name={icon} />
          </View>
        ) : null}
      </FlexContainer>
      <FlexContainer className={styles.Body} column {...rest}>
        {children}
      </FlexContainer>
    </ContentBlock>
  );
};

IconBlock.displayName = 'IconBlock';

export default IconBlock;
